import TileLayer from 'ol/layer/Tile.js';
import TileWMS from 'ol/source/TileWMS';
import TileGrid from 'ol/tilegrid/TileGrid';
import {RESOLUTIONS, KIJS} from '../config';

export var wmsLayer = new TileLayer({
	title: "KIJS",
//	saturation:0.6,
//	hue:-1.0,
	source: new TileWMS({
		url: location.protocol + '//wms.kartes.lv/' + KIJS + '/wgs/15/',
		params: {LAYERS: '0', VERSION: '1.1.1'},
		tileGrid: new TileGrid({
			origin: [-20037508.342787001, -20037508.342787001],
			resolutions: RESOLUTIONS
		}),
		crossOrigin: 'anonymous'
	}),
	visible: true,
});

export var wmsOrtoLayer = new TileLayer({
		title: "KIJS Photo",
		visible: false,
		preload: 'Infinity',
		source: new TileWMS({
		  url: location.protocol + '//wms.kartes.lv/' + KIJS + '/wgs/orto/',
		  params: {LAYERS: '0', VERSION: '1.1.1'},
		  tileGrid: new TileGrid({
			  origin: [-20037508.342787001, -20037508.342787001],
			  resolutions: RESOLUTIONS
		  }),
		  crossOrigin: 'anonymous'
		})
	});

export var wmsBWLayer = new TileLayer({
		title: "KIJS BW",
		visible: false,
		preload: 'Infinity',
		source: new TileWMS({
		  url: location.protocol + '//wms.kartes.lv/' + KIJS + '/wgs/15bw/',
		  params: {LAYERS: '0', VERSION: '1.1.1'},
		  tileGrid: new TileGrid({
			  origin: [-20037508.342787001, -20037508.342787001],
			  resolutions: RESOLUTIONS
		  }),
		  crossOrigin: 'anonymous'
		})
	});

export var wmsTopo75Layer = new TileLayer({
		title: "TOPO75",
		visible: false,
		preload: 'Infinity',
		source: new TileWMS({
		  url: location.protocol + '//wms.kartes.lv/' + KIJS + '/wgs/topo_old/',
		  params: {LAYERS: '0', VERSION: '1.1.1'},
		  tileGrid: new TileGrid({
			origin: [-20037508.342787001, 20037508.342787001],
			resolutions: RESOLUTIONS
		  }),
		  crossOrigin: 'anonymous'
		})
	});




// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/baseLayers/assets.js